export class OrganizationBillingsBuilder {
    constructor() {
        this.billing = {};
    }

    setOrganizationName(name) {
        this.billing.organizationName = name;
        return this;
    }

    setBillingDate(value) {
        this.billing.billingDate = value;
        return this;
    }

    setAmountCharged(value) {
        this.billing.amountCharged = value;
        return this;
    }

    setProductSku(value) {
        this.billing.productSku = value;
        return this;
    }

    setChannelType(value) {
        this.billing.channelType = value;
        return this;
    }

    build() {
        return this.billing;
    }
}
